import React from 'react';
import PropTypes from 'prop-types';
import { ResultWrapper, ResultLabel } from './styles';
import * as matchStatus from '../../../constants';

const Result = ({
  awayRes, homeRes, size, margin, withCursor, status, isFav, awayPenRes, homePenRes,
}) => {
  const isHomeWinner = () => (Number(homeRes) + Number(homePenRes) > Number(awayRes) + Number(awayPenRes));
  const isAwayWinner = () => (Number(homeRes) + Number(homePenRes) < Number(awayRes) + Number(awayPenRes));
  const isLive = () => status === matchStatus.LIVE_STATUS;
  const homeResult = () => {
    if (status === matchStatus.POSTPONED_STATUS || status === matchStatus.PREMATCH_STATUS || status === matchStatus.CANCELLED_STATUS || status === matchStatus.NOTPLAYED_STATUS) {
      return '-';
    }
    return Number(homeRes) + Number(homePenRes);
  };
  const awayResult = () => {
    if (status === matchStatus.POSTPONED_STATUS || status === matchStatus.PREMATCH_STATUS || status === matchStatus.CANCELLED_STATUS || status === matchStatus.NOTPLAYED_STATUS) {
      return '-';
    }
    return Number(awayRes) + Number(awayPenRes);
  };
  return (
    <ResultWrapper
      className={isLive() ? 'nowLive' : 'notLive'}
      withCursor={withCursor}
      margin={margin}
      isFav={isFav}
    >
      <ResultLabel
        color={isLive() ? 'liveColor' : 'black'}
        size={size}
        font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
      >
        {homeResult()}
      </ResultLabel>
      {/*<IconFont
          className={'icon-matchcenter-dash'}
          color={'black'}
        />*/}
      <ResultLabel
        color={isLive() ? 'liveColor' : 'black'}
        size={size}
        font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
      >
        {awayResult()}
      </ResultLabel>
    </ResultWrapper>
  );
};

Result.propTypes = {
  awayRes: PropTypes.any,
  homeRes: PropTypes.any,
  awayPenRes: PropTypes.any,
  homePenRes: PropTypes.any,
  size: PropTypes.number,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  status: PropTypes.any,
  isFav: PropTypes.bool,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/TimeResults/Result/index.js